import { Link } from 'react-router-dom';

export default function LGPDHero() {
  return (
    <section className="relative bg-navy-dark pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 rounded-full bg-teal" style={{ filter: 'blur(80px)' }} />
        <div className="absolute bottom-0 right-20 w-64 h-64 rounded-full bg-coral" style={{ filter: 'blur(100px)' }} />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-teal/20 border border-teal/30 text-teal-light px-4 py-1.5 rounded-full text-xs font-600 font-sans mb-8">
          <i className="ri-shield-check-line" />
          Lei Geral de Proteção de Dados — LGPD
        </div>

        <h1 className="font-serif text-4xl md:text-5xl font-700 text-white mb-5 leading-tight">
          Política de Privacidade<br />
          <span className="text-coral-light font-300 italic text-3xl md:text-4xl">e Proteção de Dados</span>
        </h1>

        <p className="text-white/65 text-base font-sans font-300 max-w-2xl mx-auto leading-relaxed mb-8">
          Comprometemo-nos com a transparência total sobre como coletamos, usamos e protegemos
          seus dados e os dados de seu filho. Esta política foi elaborada em conformidade integral
          com a Lei nº 13.709/2018 — LGPD.
        </p>

        <div className="flex flex-wrap justify-center gap-5 text-xs font-sans text-white/50">
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line text-coral-light" />
            Última atualização: março de 2026
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-file-text-line text-coral-light" />
            Versão 1.0
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-child-line text-coral-light" />
            Inclui proteção especial de dados de crianças
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-cream to-transparent" />
    </section>
  );
}
